import { createUniqKey } from 'Utils';

export interface IEmployee {
  id: string,
  mail: string,
  title: string,
  firstName: string,
  lastName: string,
  phone: string,
  role: string,
  validSince: Date,
  validTo: Date | null,
  lastLogin: Date | null,
  createdAt: Date | null,
}

export class Employee {
  public _key: string;
  public id: string;
  public mail: string;
  public title: string;
  public firstName: string;
  public lastName: string;
  public phone: string;
  public role: string;
  public validSince: Date;
  public validTo: Date | null;
  public lastLogin: Date | null;
  public createdAt: Date | null;

  constructor(data: IEmployee) {
    this._key = createUniqKey();
    this.createdAt = data.createdAt ? new Date(data.createdAt as unknown as number * 1000) : null;
    this.validSince = new Date(data.validSince as unknown as number * 1000);
    this.validTo = data.validTo || null;
    this.lastLogin = data.lastLogin || null;

    this.id = data.id;
    this.mail = data.mail;
    this.title = data.title;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.phone = data.phone;
    this.role = data.role;
    // @ts-ignore
    this.password = '';
  }
}

export const createNewEmployee = (data: Partial<IEmployee> = {}): Employee => new Employee({
  id: data.id || 'new',
  createdAt: data.createdAt || null,
  mail: data.mail || '',
  title: data.title || '',
  firstName: data.firstName || '',
  lastName: data.lastName || '',
  phone: data.phone || '',
  role: data.role || '',
  validSince: data.validSince || new Date(),
  validTo: data.validTo || null,
  lastLogin: data.lastLogin || null,
});
